<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden sm:rounded-lg">
            <div class="relative divide-y divide-gray-200">
              <table class="min-w-full" :class="[hasMedia && 'divide-y divide-gray-200']">
                <tbody class="relative">
                  <template v-for="mediaId in accProduct.media">
                    <MediaListItem
                      :key="mediaId.id"
                      :acc-product-id="accProductId"
                      :media-id="mediaId"
                      :is-cover="mediaId === accProduct.coverMediaId"
                    />
                  </template>
                </tbody>
                <tbody class="relative">
                  <tr>
                    <td colspan="2" class="p-4 bg-white">
                      <AddMediaAction :acc-product-id="accProductId" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaListItem from './MediaListItem.vue';
import AddMediaAction from './AddMediaAction.vue';

export default {
  components: {
    MediaListItem,
    AddMediaAction,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accProduct() {
      return this.$store.state.entities.accProducts.byId[this.accProductId];
    },
    hasMedia() {
      const { media } = this.accProduct || {};
      return Array.isArray(media) && media.length > 0;
    },
  },
};
</script>
